// DS: MO0.2
import React from 'react';
import c from 'classnames';
import { URLS } from '@wix/da-url';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '../Buttons/TextButton';
import CoreSymbol from '../Indicators/CoreSymbol';
import { IconSize } from '../Icons/IconWrap';
import s from './DisclosureBanner.scss';

interface Props {
  title?: string;
  message: string;
  ctaLabel?: string;
  ctaBiData?: BiEvent;
  className?: string;
  variant?: 'vetical' | 'horizontal'; // DS: MO0.2.1 - horizontal
}

const DisclosureBanner: React.FC<Props> = ({
  title,
  message,
  ctaLabel,
  ctaBiData,
  className,
  variant = 'vetical',
}) => {
  return (
    <div className={c(s['root'], s[`variant-${variant}`], className)}>
      <div className={s['title']}>{title}</div>
      <div className={s['message']}>{message}</div>
      {ctaLabel && (
        <TextButton
          size="small"
          variant="core-orange"
          className={s['cta']}
          href={URLS.CORE_MEMBERSHIP}
          biData={ctaBiData}
        >
          <CoreSymbol className={s['core-star']} size={IconSize.MEDIUM} />
          {ctaLabel}
        </TextButton>
      )}
    </div>
  );
};
DisclosureBanner.displayName = 'DisclosureBanner';

export default DisclosureBanner;
